/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_New_Err_Source_LotInputs */

const vi_sl_new_err_source_lot = /** @type {(inputs: Sl_New_Err_Source_LotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn phiếu cân chè khô nguồn`)
};

/**

* @param {Sl_New_Err_Source_LotInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_new_err_source_lot = /** @type {((inputs?: Sl_New_Err_Source_LotInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_New_Err_Source_LotInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_new_err_source_lot(inputs)
});